import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'irar-linkage-farm-map',
  template: `
  <maphilight
    id="LinkageMap"
    [config]="config">
    <img src="../images/LinkageFarm.jpg"
    class="map"
    usemap="#LinkageFarmArea"
    alt="Beltsville Agricultural Research Center Linkage Farm"
    height="587"
    width="760"
    border="0">
    <map name="LinkageFarmArea">
      <area (click)="selectSite.emit('BARC 6')"
        alt="BARC 6"
        shape="rect"
        coords="609,375,650,390">
      <area (click)="selectSite.emit('ENTECH R5')"
        alt="ENTECH R5"
        shape="rect"
        coords="139,443,205,461">
      <area (click)="selectSite.emit('ENTECH 7')"
        alt="ENTECH 7"
        shape="rect"
        coords="255,140,308,156">
      <area (click)="selectSite.emit('EPIC 16')"
        alt="EPIC 16"
        shape="rect"
        coords="541,258,584,273">
    </map>
  </maphilight>
  `
})
export class LinkageFarmMapComponent {
  @Input() config: any;
  @Output() selectSite: EventEmitter<string> = new EventEmitter();
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/components/linkage-farm-map.ts